'use client';

import { SvgManual } from '@common/icon';
import type { PropsWithChildren } from 'react';

import { CustomLink } from '@/app/_components/CustomLink';
import { CartIconLink } from '@/app/donation/_components/CartIconLink';
import { PageNavigation } from '@/components/client';
import { DONATION_ROUTES } from '@/constants';

const InquiryLayout = ({ children }: PropsWithChildren) => {
  return (
    <article className="flex flex-col">
      <PageNavigation isNotUsedHomeButton>
        <CartIconLink />
        <CustomLink
          href={DONATION_ROUTES.GUIDE.pathname}
          aria-label="가이드 페이지로 이동"
        >
          <SvgManual className="size-24 text-Gray-900" />
        </CustomLink>
      </PageNavigation>
      {children}
    </article>
  );
};

export default InquiryLayout;
